import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=38f663bf&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=38f663bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f663bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f663bf')) {
      api.createRecord('38f663bf', component.options)
    } else {
      api.reload('38f663bf', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=38f663bf&scoped=true&", function () {
      api.rerender('38f663bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/DocBox.vue"
export default component.exports